import {
  MRH_FIELDS,
  MRH_GROUP_ORDER,
  mrhFieldMeta,
  mrhDisplayValue,
  isMrhFieldVisible
} from './mrhFieldCatalog'

export const CRM_STATUSES = [
  { id: 'A_TRAITER', label: 'À traiter', badge: 'warning' },
  { id: 'INJOIGNABLE', label: 'Injoignable', badge: 'danger' },
  { id: 'HORS_CIBLE', label: 'Hors cible', badge: 'default' },
  { id: 'RDV_PLANIFIE', label: 'RDV planifié', badge: 'info' },
  { id: 'DEVIS_ENVOYE', label: 'Devis envoyé', badge: 'info' },
  { id: 'PROMESSE', label: 'Promesse', badge: 'warning' },
  { id: 'CONTRAT_PIECES', label: 'Contrat — pièces', badge: 'info' },
  { id: 'CONTRAT_REALISE', label: 'Contrat réalisé', badge: 'success' },
  { id: 'REFUS', label: 'Refus', badge: 'danger' },
  { id: 'SOUSCRIT_AILLEURS', label: 'Souscrit ailleurs', badge: 'default' }
]

/** Segment Auto depuis leadsAnnonceur.auto_segment (API) — pas de calcul MG */
export const TARIFICATION_LABELS = {
  bons_conducteurs: 'Tarification Coverity',
  auto_rag: 'Tarification autre'
}

/** HEOMI 2 uniquement — Coverity / Autre désactivé pour les autres comptes CRM */
export const TARIFICATION_CRM_USER_ID = '3771'

export function isTarificationCrmEnabled(userId) {
  return String(userId || '') === TARIFICATION_CRM_USER_ID
}

export function tarificationLabel(lead) {
  if (!lead || Number(lead.pk_categorie) !== 2) return null
  return TARIFICATION_LABELS[lead.auto_segment] || null
}

export function tarificationBadgeClass(lead) {
  if (lead && lead.auto_segment === 'bons_conducteurs') return 'badge-info'
  if (lead && lead.auto_segment === 'auto_rag') return 'badge-secondary'
  return 'badge-default'
}

export function isTarificationAutre(lead) {
  return Number(lead && lead.pk_categorie) === 2 && lead.auto_segment === 'auto_rag'
}

export const CALL_RESULTS = [
  'Pas de réponse',
  'Messagerie',
  'Occupé',
  'Contact établi',
  'Numéro erroné',
  'Rappel demandé',
  'Refus'
]

export const MAX_CALLS = 4

export const UNASSIGNED = 'Non affecté'

export const PIECE_KINDS = [
  { key: 'piece_carte_grise', label: 'Carte grise' },
  { key: 'piece_permis', label: 'Permis de conduire' },
  { key: 'piece_releve', label: "Relevé d'informations" }
]

function smsIntro(me, society) {
  const who = me || ''
  const soc = (society || '').trim()
  if (soc) return `ici ${who} de ${soc}`
  return `ici ${who}`
}

export const SMS_TEMPLATES = {
  join: {
    key: 'join',
    label: 'Tentative de jointure + RDV',
    body: (prenom, me, society) =>
      `Bonjour ${prenom || ''}, ${smsIntro(me, society)}. J'ai tenté de vous joindre concernant votre demande d'assurance auto. Pouvez-vous me rappeler ou me proposer un créneau pour un RDV ?`
  },
  rdv: {
    key: 'rdv',
    label: 'Confirmation de rendez-vous',
    body: (prenom, me, society) =>
      `Bonjour ${prenom || ''}, ${smsIntro(me, society)}. Votre rendez-vous assurance auto est confirmé. Merci de préparer carte grise, permis et relevé d'informations.`
  },
  devis: {
    key: 'devis',
    label: 'Devis envoyé',
    body: (prenom, me, society) =>
      `Bonjour ${prenom || ''}, ${smsIntro(me, society)}. Votre devis d'assurance auto vous a été transmis. N'hésitez pas à me contacter pour toute question.`
  }
}

/** Known auto mappings → French label + tarificateur group */
export const AUTO_FIELD_CATALOG = {
  nom: { label: 'Nom', group: 'IDENTITÉ' },
  prenom: { label: 'Prénom', group: 'IDENTITÉ' },
  date_naissance: { label: 'Date de naissance', group: 'IDENTITÉ' },
  primary_gender: { label: 'Genre', group: 'IDENTITÉ' },
  genre: { label: 'Genre', group: 'IDENTITÉ' },
  sexe: { label: 'Genre', group: 'IDENTITÉ' },
  telephone: { label: 'Téléphone', group: 'IDENTITÉ' },
  tel: { label: 'Téléphone', group: 'IDENTITÉ' },
  email: { label: 'Email', group: 'IDENTITÉ' },
  adresse: { label: 'Adresse', group: 'IDENTITÉ' },
  cp: { label: 'Code postal', group: 'IDENTITÉ' },
  ville: { label: 'Ville', group: 'IDENTITÉ' },
  primary_profession: { label: 'Profession', group: 'IDENTITÉ' },
  profession: { label: 'Profession', group: 'IDENTITÉ' },
  primary_marital_status: { label: 'Statut conjugal', group: 'IDENTITÉ' },
  statut_conjugal: { label: 'Statut conjugal', group: 'IDENTITÉ' },
  primary_residence_type: { label: 'Logement', group: 'IDENTITÉ' },
  logement: { label: 'Logement', group: 'IDENTITÉ' },
  primary_occupancy_status: { label: 'Occupation', group: 'IDENTITÉ' },
  occupation: { label: 'Occupation', group: 'IDENTITÉ' },

  future_contract_type: { label: 'Couverture', group: 'CONTRAT SOUHAITÉ' },
  couverture: { label: 'Couverture', group: 'CONTRAT SOUHAITÉ' },
  type_contrat: { label: 'Couverture', group: 'CONTRAT SOUHAITÉ' },
  formule: { label: 'Couverture', group: 'CONTRAT SOUHAITÉ' },
  future_contract_date: { label: "Date d'effet", group: 'CONTRAT SOUHAITÉ' },
  date_effet: { label: "Date d'effet", group: 'CONTRAT SOUHAITÉ' },
  effet: { label: "Date d'effet", group: 'CONTRAT SOUHAITÉ' },

  brand_code: { label: 'Marque', group: 'VÉHICULE' },
  brand: { label: 'Marque', group: 'VÉHICULE' },
  marque: { label: 'Marque', group: 'VÉHICULE' },
  modele: { label: 'Modèle', group: 'VÉHICULE' },
  model: { label: 'Modèle', group: 'VÉHICULE' },
  version_name: { label: 'Version', group: 'VÉHICULE' },
  version: { label: 'Version', group: 'VÉHICULE' },
  version_commercial: { label: 'Version commerciale', group: 'VÉHICULE' },
  energy: { label: 'Énergie', group: 'VÉHICULE' },
  energie: { label: 'Énergie', group: 'VÉHICULE' },
  power: { label: 'Puissance fiscale', group: 'VÉHICULE' },
  puissance: { label: 'Puissance fiscale', group: 'VÉHICULE' },
  category: { label: 'Catégorie', group: 'VÉHICULE' },
  categorie: { label: 'Catégorie véhicule', group: 'VÉHICULE' },
  gearbox: { label: 'Boîte', group: 'VÉHICULE' },
  boite: { label: 'Boîte', group: 'VÉHICULE' },
  registration_date: { label: '1ère mise en circulation', group: 'VÉHICULE' },
  mise_en_circulation: { label: '1ère mise en circulation', group: 'VÉHICULE' },
  purchase_date: { label: "Date d'achat", group: 'VÉHICULE' },
  date_achat: { label: "Date d'achat", group: 'VÉHICULE' },
  plate_number: { label: 'Immatriculation', group: 'VÉHICULE' },
  immatriculation: { label: 'Immatriculation', group: 'VÉHICULE' },
  estimated_value: { label: 'Valeur estimée', group: 'VÉHICULE' },
  valeur: { label: 'Valeur estimée', group: 'VÉHICULE' },
  used_for: { label: 'Usage', group: 'VÉHICULE' },
  usage: { label: 'Usage', group: 'VÉHICULE' },
  annual_km: { label: 'Km / an', group: 'VÉHICULE' },
  km: { label: 'Km / an', group: 'VÉHICULE' },
  night_parking: { label: 'Stationnement nuit', group: 'VÉHICULE' },
  stationnement: { label: 'Stationnement nuit', group: 'VÉHICULE' },
  night_parking_cp: { label: 'CP stationnement', group: 'VÉHICULE' },
  night_parking_city: { label: 'Ville stationnement', group: 'VÉHICULE' },
  graycard_owner: { label: 'Titulaire carte grise', group: 'VÉHICULE' },
  carte_grise: { label: 'Titulaire carte grise', group: 'VÉHICULE' },

  primary_license_type: { label: 'Type de permis', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  permis: { label: 'Type de permis', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_license_date: { label: 'Date de permis', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  date_permis: { label: 'Date de permis', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_bonus_malus: { label: 'Bonus-malus', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  bonus: { label: 'Bonus-malus', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  malus: { label: 'Bonus-malus', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_years_top_bonus: { label: 'Années bonus 50%', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_claims_number: { label: 'Sinistres 3 ans', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  sinistre: { label: 'Sinistres 3 ans', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_drunk_driving: { label: 'Alcoolémie', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  alcool: { label: 'Alcoolémie', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_license_suspension: { label: 'Suspension permis', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  suspension: { label: 'Suspension permis', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_insurance_past_status: { label: 'Déjà assuré', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_insurance_present_status: { label: 'Actuellement', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_insurance_company: { label: 'Assureur', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  assureur: { label: 'Assureur', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_insurance_interruption: { label: 'Interruption 24 mois', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_partner_license_status: { label: 'Conjoint permis', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  conjoint: { label: 'Conjoint permis', group: 'CONDUCTEUR / PERMIS / ASSURANCE' },
  primary_partner_birth_date: { label: 'Naissance conjoint', group: 'CONDUCTEUR / PERMIS / ASSURANCE' }
}

const AUTO_GROUP_ORDER = [
  'IDENTITÉ',
  'CONTRAT SOUHAITÉ',
  'VÉHICULE',
  'CONDUCTEUR / PERMIS / ASSURANCE',
  'Autres attributs'
]

/** Groupes MonGustave (détails auto via showDetailsLeadAutoMg) */
const MG_GROUP_ORDER = [
  'IDENTITÉ',
  'CONTRAT SOUHAITÉ',
  'VÉHICULE',
  'CONDUCTEUR PRINCIPAL',
  'PERMIS',
  'ASSURANCE',
  'SINISTRE',
  'CONDUCTEUR SECONDAIRE',
  'Autres attributs'
]

const VEHICLE_KEYS = [
  'brand',
  'marque',
  'modele',
  'model',
  'version',
  'energy',
  'energie',
  'power',
  'puissance',
  'gearbox',
  'boite',
  'registration',
  'circulation',
  'purchase',
  'achat',
  'plate',
  'immat',
  'estimated',
  'valeur',
  'used_for',
  'usage',
  'annual_km',
  'km',
  'parking',
  'stationnement',
  'graycard',
  'carte_grise',
  'category',
  'categorie'
]

/** Equivalents QQ ↔ MonGustave pour ne pas perdre marque/modèle au merge */
const FIELD_KEY_ALIASES = {
  marque: ['marque', 'brand', 'brand_code'],
  brand: ['marque', 'brand', 'brand_code'],
  brand_code: ['marque', 'brand', 'brand_code'],
  modele: ['modele', 'model'],
  model: ['modele', 'model']
}

function mappingCoveredBy(keysSet, mappingKey) {
  if (!mappingKey) return false
  if (keysSet.has(mappingKey)) return true
  const aliases = FIELD_KEY_ALIASES[mappingKey]
  if (!aliases) return false
  return aliases.some((a) => keysSet.has(a))
}

/**
 * Quand MG est OK, on enrichit avec les inputs QQ remplis absents de MG
 * (cas fréquent : marque / modele QQ alors que MG ne les renvoie pas).
 */
export function mergeMgAndQqInputs(mgInputs, qqInputs) {
  const mgFilled = filterDisplayInputs(mgInputs)
  const covered = new Set(
    mgFilled.map((i) => normalizeKey(i.mapping)).filter(Boolean)
  )
  const out = [...mgFilled]
  filterDisplayInputs(qqInputs).forEach((q) => {
    const k = normalizeKey(q.mapping)
    if (mappingCoveredBy(covered, k)) return
    out.push(q)
    if (k) covered.add(k)
  })
  return out
}

const IDENTITY_KEYS = [
  'nom',
  'prenom',
  'first_name',
  'last_name',
  'birth',
  'naissance',
  'gender',
  'genre',
  'sexe',
  'phone',
  'tel',
  'email',
  'adresse',
  'address',
  'cp',
  'postal',
  'ville',
  'city',
  'profession',
  'marital',
  'conjugal',
  'residence',
  'logement',
  'occupancy',
  'occupation'
]

export function statusMeta(id) {
  return CRM_STATUSES.find((s) => s.id === id) || CRM_STATUSES[0]
}

export function emptyCrmState(pkLead) {
  return {
    pk_lead: pkLead,
    status: 'A_TRAITER',
    callback_at: null,
    calls_count: 0,
    owner_commercial_id: null,
    owner_commercial_name: null,
    piece_carte_grise: false,
    piece_permis: false,
    piece_releve: false,
    calls: [],
    sms: [],
    comments: []
  }
}

/** Merge API CRM payload without letting null/undefined wipe local fields */
export function mergeDefinedCrmFields(base, apiState) {
  const merged = { ...base }
  if (!apiState) return merged
  Object.keys(apiState).forEach((key) => {
    const val = apiState[key]
    if (val !== null && val !== undefined) {
      merged[key] = val
    }
  })
  return merged
}

export const CRM_OPERATOR_STORAGE_KEY = 'crm_v2_operator_id'

export function getStoredOperatorId() {
  try {
    return localStorage.getItem(CRM_OPERATOR_STORAGE_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function setStoredOperatorId(id) {
  try {
    if (!id) localStorage.removeItem(CRM_OPERATOR_STORAGE_KEY)
    else localStorage.setItem(CRM_OPERATOR_STORAGE_KEY, String(id))
  } catch (e) {
    /* ignore */
  }
}

export function isSupervisorUser() {
  try {
    const u = JSON.parse(localStorage.getItem('utilisateur') || '{}')
    if (u.law === 'ad') return true
    if (localStorage.getItem('user_origine_id') != null) return true
    return false
  } catch (e) {
    return false
  }
}

export function commercialLabel(c) {
  if (!c) return UNASSIGNED
  return [c.prenom, c.nom].filter(Boolean).join(' ').trim() || c.email || String(c.id)
}

export function currentUserLabel() {
  try {
    const u = JSON.parse(localStorage.getItem('utilisateur') || '{}')
    const name = [u.prenom, u.nom].filter(Boolean).join(' ').trim()
    return name || u.email || String(u.id || 'Utilisateur')
  } catch (e) {
    return 'Utilisateur'
  }
}

/** Société du compte annonceur connecté (SMS modèles) */
export function currentClientSociety() {
  try {
    const u = JSON.parse(localStorage.getItem('utilisateur') || '{}')
    return String(u.society || '').trim()
  } catch (e) {
    return ''
  }
}

export function isFilledValue(v) {
  if (v === null || v === undefined) return false
  const s = String(v).trim()
  return s !== '' && s !== '\\N' && s.toLowerCase() !== 'null'
}

/** Affiche les dates ISO en JJ/MM/AAAA pour le copier-coller */
export function prettyValue(v) {
  if (!isFilledValue(v)) return '—'
  const s = String(v).trim()
  // YYYY-MM-DD or YYYY-MM-DD HH:mm:ss / ISO with T
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T].*)?$/)
  if (m) return `${m[3]}/${m[2]}/${m[1]}`
  return s.replace(/_/g, ' ')
}

/** Date+heure de rappel pour la colonne liste : JJ/MM/AAAA HH:mm */
export function prettyCallbackAt(v) {
  if (!isFilledValue(v)) return '—'
  const s = String(v).trim()
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2})?)?/)
  if (!m) return prettyValue(v)
  const date = `${m[3]}/${m[2]}/${m[1]}`
  if (m[4] != null && m[5] != null) return `${date} ${m[4]}:${m[5]}`
  return date
}

/** Extrait YYYY-MM-DD depuis callback API (espace ou T) */
export function callbackDay(iso) {
  if (!iso) return null
  const s = String(iso).trim()
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/)
  return m ? m[1] : null
}

/**
 * Compare le jour du rappel à aujourd’hui.
 * @returns {'today'|'upcoming'|'overdue'|null}
 */
export function callbackRelative(iso, day = todayIso()) {
  const d = callbackDay(iso)
  if (!d) return null
  if (d === day) return 'today'
  if (d > day) return 'upcoming'
  return 'overdue'
}

export function countFilledAttrs(groups) {
  return (groups || []).reduce((n, g) => n + ((g.rows && g.rows.length) || 0), 0)
}

export function isSameDay(iso, day) {
  const d = callbackDay(iso)
  if (!d) return false
  return d === day
}

export function todayIso() {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

/** YYYY-MM-DD à N jours avant aujourd’hui */
export function daysAgoIso(n) {
  const d = new Date()
  d.setDate(d.getDate() - (Number(n) || 0))
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

/** Compare tél. sans espaces / points / tirets */
export function normalizePhone(v) {
  return String(v || '').replace(/[\s.\-()]/g, '')
}

/** Fix common mojibake from API (Ã© → é, etc.) */
export function fixUtf8Label(str) {
  if (!str) return ''
  return String(str)
    .replace(/Ã©/g, 'é')
    .replace(/Ã¨/g, 'è')
    .replace(/Ãª/g, 'ê')
    .replace(/Ã /g, 'à')
    .replace(/Ã¢/g, 'â')
    .replace(/Ã´/g, 'ô')
    .replace(/Ã»/g, 'û')
    .replace(/Ã§/g, 'ç')
    .replace(/Ã‰/g, 'É')
    .replace(/ÃŽ/g, 'Î')
    .replace(/Â /g, ' ')
    .replace(/Â/g, '')
}

function normalizeKey(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9_]+/g, '_')
    .replace(/^_|_$/g, '')
}

function resolveCatalogEntry(mapping, champs) {
  const keys = [
    normalizeKey(mapping),
    String(mapping || '').toLowerCase().trim(),
    normalizeKey(champs)
  ]
  for (const k of keys) {
    if (k && AUTO_FIELD_CATALOG[k]) return AUTO_FIELD_CATALOG[k]
  }
  // fuzzy: catalog key contained in mapping/champs
  const hay = `${mapping || ''} ${champs || ''}`.toLowerCase()
  for (const [key, meta] of Object.entries(AUTO_FIELD_CATALOG)) {
    if (hay.includes(key)) return meta
  }
  return null
}

export function isAutoProduct(lead, inputs) {
  const fk =
    lead &&
    (lead.fk_categorie != null
      ? lead.fk_categorie
      : lead.pk_categorie != null
        ? lead.pk_categorie
        : null)
  if (fk != null && Number(fk) === 2) return true

  const c = String((lead && lead.categorie) || '').toLowerCase()
  if (
    c.includes('auto') ||
    c.includes('assurance auto') ||
    c.includes('vehicule') ||
    c.includes('véhicule') ||
    c.includes('automobile')
  ) {
    return true
  }
  // Infer from inputs mappings (brand, bonus-malus, etc.)
  const list = inputs || []
  let hits = 0
  for (const i of list) {
    if (resolveCatalogEntry(i.mapping, i.champs)) hits += 1
    if (hits >= 3) return true
  }
  return false
}

function hayHasAny(hay, keys) {
  return keys.some((k) => hay.includes(k))
}

/**
 * Route MonGustave mapping → groupe d’affichage.
 * secondary_* → conducteur 2 ; primary_* → sous-groupes ; sinon identité / véhicule / contrat.
 */
export function resolveMgGroup(mapping, champs) {
  const map = normalizeKey(mapping)
  const hay = `${map} ${normalizeKey(champs)} ${String(mapping || '').toLowerCase()} ${String(champs || '').toLowerCase()}`

  if (map.startsWith('secondary_') || hay.includes('secondary_')) {
    return 'CONDUCTEUR SECONDAIRE'
  }

  if (map.startsWith('primary_') || hay.includes('primary_')) {
    if (hayHasAny(hay, ['license', 'permis', 'partner_license'])) return 'PERMIS'
    if (hayHasAny(hay, ['insurance', 'assureur', 'bonus', 'malus'])) return 'ASSURANCE'
    if (hayHasAny(hay, ['claim', 'sinistre', 'accident'])) return 'SINISTRE'
    return 'CONDUCTEUR PRINCIPAL'
  }

  if (hayHasAny(hay, ['future_contract', 'couverture', 'date_effet', 'type_contrat', 'formule'])) {
    return 'CONTRAT SOUHAITÉ'
  }

  const meta = resolveCatalogEntry(mapping, champs)
  if (meta && meta.group) {
    if (meta.group === 'IDENTITÉ') return 'IDENTITÉ'
    if (meta.group === 'CONTRAT SOUHAITÉ') return 'CONTRAT SOUHAITÉ'
    if (meta.group === 'VÉHICULE') return 'VÉHICULE'
    if (meta.group === 'CONDUCTEUR / PERMIS / ASSURANCE') {
      if (hayHasAny(hay, ['license', 'permis'])) return 'PERMIS'
      if (hayHasAny(hay, ['insurance', 'assureur', 'bonus', 'malus'])) return 'ASSURANCE'
      if (hayHasAny(hay, ['claim', 'sinistre'])) return 'SINISTRE'
      return 'CONDUCTEUR PRINCIPAL'
    }
  }

  if (hayHasAny(hay, VEHICLE_KEYS)) return 'VÉHICULE'
  if (hayHasAny(hay, IDENTITY_KEYS)) return 'IDENTITÉ'
  return 'Autres attributs'
}

function leadIdentityRows(lead) {
  return [
    { label: 'Nom', value: lead && lead.nom, key: 'nom' },
    { label: 'Prénom', value: lead && lead.prenom, key: 'prenom' },
    { label: 'Date de naissance', value: lead && lead.date_naissance, key: 'date_naissance' },
    { label: 'Téléphone', value: lead && lead.telephone, key: 'telephone' },
    { label: 'Email', value: lead && lead.email, key: 'email' },
    { label: 'Adresse', value: lead && lead.adresse, key: 'adresse' },
    { label: 'Code postal', value: lead && lead.cp, key: 'cp' },
    { label: 'Ville', value: lead && lead.ville, key: 'ville' }
  ]
    .filter((r) => isFilledValue(r.value))
    .map((r) => ({ label: r.label, value: prettyValue(r.value), key: r.key }))
}

function isProvenanceField(mapping, champs) {
  const hay = `${normalizeKey(mapping)} ${normalizeKey(champs)} ${String(mapping || '')} ${String(champs || '')}`.toLowerCase()
  return hay.includes('provenance')
}

function filterDisplayInputs(inputs) {
  return (inputs || []).filter((i) => {
    if (!i) return false
    if (String(i.mapping || '').toLowerCase() === 'tel') return false
    if (isProvenanceField(i.mapping, i.champs)) return false
    return isFilledValue(i.value)
  })
}

function consentRowsFromSources(lead, consent) {
  const phrase =
    consent && isFilledValue(consent.phrase_optin)
      ? consent.phrase_optin
      : lead && lead.phrase_optin
  const site =
    consent && isFilledValue(consent.site_collecte)
      ? consent.site_collecte
      : lead && lead.site_collecte
  return [
    { label: "Phrase d'optin", value: phrase },
    { label: 'Site de collecte', value: site },
    { label: 'Date de collecte', value: lead && lead.date_collecte },
    { label: 'Facturation', value: lead && lead.facturation },
    { label: 'Statut qualité', value: lead && lead.statut },
    { label: 'Produit', value: lead && lead.categorie },
    { label: 'Pack', value: lead && lead.pack }
  ]
    .filter((r) => isFilledValue(r.value))
    .map((r) => ({ label: r.label, value: prettyValue(r.value) }))
}

/**
 * Groupes depuis showDetailsLeadAutoMg.inputs (labels = champs FR).
 * Préfixe identité lead si absente des réponses MG.
 * consent: { phrase_optin, site_collecte } depuis la réponse MG (toujours présents).
 */
export function buildFieldGroupsFromMg(lead, inputs, consent) {
  const filledInputs = filterDisplayInputs(inputs)

  const buckets = {}
  MG_GROUP_ORDER.forEach((t) => {
    buckets[t] = []
  })

  const seenKeys = new Set()
  const seenLabels = new Set()

  filledInputs.forEach((i) => {
    const group = resolveMgGroup(i.mapping, i.champs)
    const label = fixUtf8Label(i.champs || 'Champ')
    const mapKey = normalizeKey(i.mapping)
    if (mapKey && seenKeys.has(mapKey)) return
    if (seenLabels.has(label.toLowerCase())) return
    if (!buckets[group]) buckets[group] = []
    buckets[group].push({ label, value: prettyValue(i.value), key: mapKey || undefined })
    if (mapKey) seenKeys.add(mapKey)
    seenLabels.add(label.toLowerCase())
  })

  // Préfixe identité lead si non déjà couverte par MG
  const identityFromLead = leadIdentityRows(lead).filter((r) => {
    if (r.key && seenKeys.has(r.key)) return false
    if (seenLabels.has(String(r.label).toLowerCase())) return false
    return true
  })
  if (identityFromLead.length) {
    buckets.IDENTITÉ = [...identityFromLead, ...(buckets.IDENTITÉ || [])]
  }

  const groups = MG_GROUP_ORDER.filter((t) => buckets[t] && buckets[t].length).map((t) => ({
    title: t,
    rows: buckets[t]
  }))

  const consentRows = consentRowsFromSources(lead, consent)
  if (consentRows.length) groups.push({ title: 'CONSENTEMENT', rows: consentRows })
  return groups
}

export function isMrhProduct(lead) {
  if (!lead || isAutoProduct(lead, [])) return false
  const c = normalizeKey(lead.categorie)
  return c.includes('habitation') || c.includes('mrh')
}

/**
 * Groupes depuis showDetailsLeadMrhMg.inputs : uniquement les attributs du catalogue MRH,
 * libellés + valeurs traduits, conditions d'affichage appliquées.
 */
export function buildFieldGroupsFromMrh(lead, inputs, consent) {
  const valuesByKey = {}
  filterDisplayInputs(inputs).forEach((i) => {
    const meta = mrhFieldMeta(i.mapping)
    if (meta && valuesByKey[meta.key] === undefined) valuesByKey[meta.key] = String(i.value).trim()
  })

  const buckets = {}
  MRH_GROUP_ORDER.forEach((t) => {
    buckets[t] = []
  })
  const seenKeys = new Set()

  MRH_FIELDS.forEach((field) => {
    const raw = valuesByKey[field.key]
    if (!isFilledValue(raw) || !isMrhFieldVisible(field, valuesByKey)) return
    buckets[field.group].push({
      label: field.label,
      value: prettyValue(mrhDisplayValue(field, raw)),
      key: normalizeKey(field.key)
    })
    seenKeys.add(normalizeKey(field.key))
  })

  const identityFromLead = leadIdentityRows(lead).filter((r) => !seenKeys.has(r.key))
  if (identityFromLead.length) {
    buckets['IDENTITÉ'] = [...identityFromLead, ...buckets['IDENTITÉ']]
  }

  const groups = MRH_GROUP_ORDER.filter((t) => buckets[t].length).map((t) => ({
    title: t,
    rows: buckets[t]
  }))

  const consentRows = consentRowsFromSources(lead, consent)
  if (consentRows.length) groups.push({ title: 'CONSENTEMENT', rows: consentRows })
  return groups
}

/**
 * Build display groups from showDetailsLead.inputs + lead identity.
 * Only filled values are kept. Auto products → tarificateur groups.
 */
export function buildFieldGroups(lead, inputs, forceAuto, consent) {
  const filledInputs = filterDisplayInputs(inputs)
  const auto = forceAuto != null ? forceAuto : isAutoProduct(lead, filledInputs)

  const identityRows = leadIdentityRows(lead)

  const consentRows = consentRowsFromSources(lead, consent)

  if (!auto) {
    const other = filledInputs.map((i) => ({
      label: fixUtf8Label(i.champs || i.mapping || 'Champ'),
      value: prettyValue(i.value)
    }))
    const groups = []
    if (identityRows.length) groups.push({ title: 'IDENTITÉ', rows: identityRows })
    if (other.length) groups.push({ title: 'ATTRIBUTS', rows: other })
    if (consentRows.length) groups.push({ title: 'CONSENTEMENT', rows: consentRows })
    return groups
  }

  const buckets = {
    IDENTITÉ: [...identityRows],
    'CONTRAT SOUHAITÉ': [],
    VÉHICULE: [],
    'CONDUCTEUR / PERMIS / ASSURANCE': [],
    'Autres attributs': []
  }
  const seenKeys = new Set(identityRows.map((r) => r.key).filter(Boolean))
  const seenLabels = new Set(identityRows.map((r) => r.label.toLowerCase()))

  filledInputs.forEach((i) => {
    const meta = resolveCatalogEntry(i.mapping, i.champs)
    const group = (meta && meta.group) || 'Autres attributs'
    const label = fixUtf8Label((meta && meta.label) || i.champs || i.mapping || 'Champ')
    const mapKey = normalizeKey(i.mapping)
    if (mapKey && seenKeys.has(mapKey)) return
    if (seenLabels.has(label.toLowerCase())) return
    if (!buckets[group]) buckets[group] = []
    buckets[group].push({ label, value: prettyValue(i.value) })
    if (mapKey) seenKeys.add(mapKey)
    seenLabels.add(label.toLowerCase())
  })

  const groups = AUTO_GROUP_ORDER.filter((t) => buckets[t] && buckets[t].length).map((t) => ({
    title: t,
    rows: buckets[t]
  }))

  if (consentRows.length) groups.push({ title: 'CONSENTEMENT', rows: consentRows })
  return groups
}
